// 任务状态机（原设计 4.4）：以后端为准，Workboard 只做粗粒度调度
import type { Priority, TaskStatus } from "./types.js";

const TRANSITIONS: Record<TaskStatus, TaskStatus[]> = {
  draft: ["ready", "cancelled"],
  ready: ["draft", "queued", "cancelled"],
  queued: ["running", "ready", "cancelled"],
  running: ["waiting_scan", "review_required", "blocked", "done", "failed", "cancelled"],
  waiting_scan: ["running", "blocked", "cancelled"],
  review_required: ["running", "blocked", "cancelled", "done"],
  blocked: ["waiting_scan", "running", "failed", "cancelled", "queued", "ready", "done"],
  // dry run 做完（没提交）可以从头重启再跑一次；真提交过的 done 由后端拦住
  done: ["archived", "queued"],
  failed: ["archived", "queued"],
  cancelled: ["archived"],
  archived: [],
};

export function canTransition(from: TaskStatus, to: TaskStatus): boolean {
  return TRANSITIONS[from].includes(to);
}

export function nextStatuses(from: TaskStatus): TaskStatus[] {
  return [...TRANSITIONS[from]];
}

export const ACTIVE_STATUSES: TaskStatus[] = ["running", "waiting_scan", "review_required", "blocked"];
export const TERMINAL_STATUSES: TaskStatus[] = ["done", "failed", "cancelled", "archived"];

export function isActive(s: TaskStatus): boolean {
  return ACTIVE_STATUSES.includes(s);
}

/** Workboard 卡片状态映射（原设计 4.4 末段） */
export type CardStatus = "ready" | "running" | "blocked" | "done" | "backlog";
export function toCardStatus(s: TaskStatus): CardStatus {
  switch (s) {
    case "queued":
      return "ready";
    case "running":
      return "running";
    case "waiting_scan":
    case "review_required":
    case "blocked":
      return "blocked";
    case "done":
    case "failed":
    case "cancelled":
    case "archived":
      return "done";
    default:
      return "backlog";
  }
}

export const PRIORITY_RANK: Record<Priority, number> = { urgent: 0, high: 1, normal: 2, low: 3 };

/** 派发排序：priority → 入队时间 */
export function comparePriority(
  a: { priority: Priority; queuedAt: Date | string },
  b: { priority: Priority; queuedAt: Date | string },
): number {
  const d = PRIORITY_RANK[a.priority] - PRIORITY_RANK[b.priority];
  if (d !== 0) return d;
  return new Date(a.queuedAt).getTime() - new Date(b.queuedAt).getTime();
}

/** 状态显示（原设计 4.5） */
export const STATUS_META: Record<TaskStatus, { label: string; color: string }> = {
  draft: { label: "草稿", color: "#9aa0a6" },
  ready: { label: "就绪", color: "#9aa0a6" },
  queued: { label: "排队中", color: "#80868b" },
  running: { label: "执行中", color: "#1a73e8" },
  waiting_scan: { label: "等扫码", color: "#f29900" },
  review_required: { label: "等审核", color: "#9334e6" },
  blocked: { label: "卡住", color: "#d93025" },
  done: { label: "完成", color: "#188038" },
  failed: { label: "失败", color: "#5f6368" },
  cancelled: { label: "已取消", color: "#5f6368" },
  archived: { label: "已归档", color: "#5f6368" },
};
